import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import DirectorsIcon from "../../assets/Icon/DirectorsFpoIcon.png";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomCard from "../../components/Famer/GenericCard";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";
export default function DirectorsCeoList() {
  const [fpoDetails, setFPODetails] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const { showAlert } = useAlert();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  useEffect(() => {
    api
      .get(`/fpo/get-fpo-persona-list/`)
      .then((response) => {
        setFPODetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching lenders:", error);
      });
  }, []);

  // const deleteMember = (id) => {
  //   if (!window.confirm("Are you sure you want to delete this member?")) return;

  //   api.post(`/fpo/delete-fpo-persona/?id=${id}`).then((response) => {
  //     alert("Member deleted successfully");
  //     window.location.reload();
  //   });
  // };
  const handleDelete = (id) => {
    setSelectedMemberId(id);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    api
      .post(`/fpo/delete-fpo-persona/?id=${selectedMemberId}`)
      .then((response) => {
        console.log("Member deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      });
  };
  const handleAddFpoMember = () => {
    navigate("/fpo/members/add");
  };

  const handleEditClick = (fpoId) => {
    navigate(`/fpo/members/add/?fpoId=${fpoId}`);
  };
  console.log("detaiuls", fpoDetails);
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: fpoDetails.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {fpoDetails.length !== 0 && (
            <CustomTitle>{t("Director and CEO")}</CustomTitle>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {fpoDetails.map((fpo) => (
              <CustomCard
                key={fpo.id}
                id={fpo.id}
                t={t}
                data={{
                  [t("Name")]: fpo.full_name,
                  [t("Mobile Number")]: fpo.mobile,
                  [t("Member Type")]: fpo.designation,
                  [t("Aadhar Number")]: fpo.aadhar_number,
                  [t("Pan Number")]: fpo.pan_number,
                  [t("Address")]: fpo.address,
                }}
                handleEditClick={() => handleEditClick(fpo.id)}
                handleDelete={() => handleDelete(fpo?.id)}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {fpoDetails.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={DirectorsIcon}
                  alt="Directors Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleAddFpoMember}>
              {t("Add Fpo Member")}
            </CustomButton>
            {fpoDetails.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your Member will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        message="Are you sure you want to delete this member?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
